import React from "react";
import { ProcessoBeneficioEntidade } from "../../entidades";

import { ProcessoButtonContainer, ProcessoButton } from "./styles";

interface IProps {
  processos: Array<ProcessoBeneficioEntidade>;
  onChange: (processo: ProcessoBeneficioEntidade) => void;
  dsProcessoAtivo: string;
  textoInstrucao: string;
}

const ListaProcesso: React.FC<IProps> = ({
  processos,
  onChange,
  dsProcessoAtivo,
  textoInstrucao
}) => {

  if (processos.length < 2) {
    return null;
  }

  return (
    <div>
      <span className={"text-primary"}>
        {textoInstrucao}
      </span>
      <div>
        {processos.map((processo: ProcessoBeneficioEntidade, index: number) => (
          <ProcessoButtonContainer key={index}>
            <ProcessoButton
              ativo={processo.DS_PROCESSO === dsProcessoAtivo}
              disabled={processo.DS_PROCESSO === dsProcessoAtivo}
              onClick={() => onChange(processo)}
            >
              <b>{processo.DS_ESPECIE}</b>
              <div>{processo.ANO_PROCESSO + "/" + processo.NUM_PROCESSO + " - " + processo.DT_CONCESSAO}</div>
            </ProcessoButton>
          </ProcessoButtonContainer>
        ))}
      </div>
    </div>
  );
};

export default ListaProcesso;